import { lazy } from "react"

export const SupportMembers = lazy(() => import("views/supportMembers/Index"))
export const SupportMemberFormModal = lazy(() => import("views/supportMembers/components/SupportMemberFormModal"))
export const InviteSupportInCompanyFormModal = lazy(() => import("views/supportMembers/components/InviteSupportInCompanyFormModal"))
export const SupportMembersDataGrid = lazy(() => import("components/supportMembersDataGrid/SupportMembersDataGrid"))